import React, { useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { DEFAULT_STORE } from "constants/variables.jsx";
import { LIMIT_PAGE_SIZE, ENDPOINT, NON_ERASABLE_USERACCOUNT_ID, DELETE_CODE, DEFAULT_ROLE } from "constants/variables";
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TableSortingUserAccount  from "pages/users/SortingTablesUserAccount";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "usernameFrom":"",
  "usernameTo":"",
  "aliasuserFrom":"",
  "aliasuserTo":"",
  "firstNameFrom":"",
  "firstNameTo":"",
  "lastName1From":"",
  "lastName1To":"",
  "lastName2From":"",
  "lastName2To":"",
  "emailFrom":"",
  "emailTo":"", 
  "isEnabled":true,
  "isNotEnabled":true,
  "isAccountNonLocked":true,
  "isNotAccountNonLocked":true
};

const initialState = [{
  "id" : "",
  "username" : "",
  "aliasuser":"",
  "password" : "",
  "firstName" : "",
  "lastName1" : "",
  "lastName2" : "",
  "email" : "",
  "enabled":true,
  "isAccountNonLocked":true, 
  "destinestore_id":0,
  "destinestore_name":"",
  "emaildestine":"", 
  "store_id":1,
  "store_name":"",
  "role_id":3,
  "role_name":""
   
 }];

const headCells = [
  {
    id: 'id',
    numeric: false,
    disablePadding: false,
    label: 'Text_Code',
    canOrder:true,
  },
  {
    id: 'username',
    numeric: false,
    disablePadding: false,
    label: 'Text_User',
    canOrder:true,
  },
  {
    id: 'aliasuser',
    numeric: false,
    disablePadding: false,
    label: 'Text_AliasUser',
    canOrder:true,
  },
  {
    id: 'firstName',
    numeric: false,
    disablePadding: false,
    label: 'Text_Name',
    canOrder:true,
  },
  {
    id: 'lastName1',
    numeric: false,
    disablePadding: false,
    label: 'Text_LastName1',
    canOrder:true,
  },
  {
    id: 'lastName2',
    numeric: false,
    disablePadding: false,
    label: 'Text_LastName2',
    canOrder:true,
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'Text_Email',
    canOrder:true,
  }, 
  {
    id: 'enabled',
    numeric: false,
    disablePadding: false,
    label: 'Text_Enabled',
    canOrder:false,
  },
  {
    id: 'isAccountNonLocked',
    numeric: false,
    disablePadding: false,
    label: 'Text_isAccountNonLocked',
    canOrder:false,
  },
  {
    id: 'role_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_User_Roles',
    canOrder:true,
  },
  {
    id: 'store_name',
    numeric: false,
    disablePadding: false,
    label: 'Text_User_Stores',
    canOrder:true,
  } 
];
  
const initialRolesToSelect = [{
  "id":0,
  "name":""
}];

const initialStoreToSelect = [{
  "id":0,
  "deafaultStore":true,
  "name":"",
  "tradename":""
}];

const initialEmailToSelect = [{
  "id":"",
  "tradename": "",
  "contacemail":""
 }];
 
const UserSettings = ({setShowPrincipalMenu,showUserSettings, setShowModalUserSettings,setShowModalGeneralSettings}) => {
  const {t,i18n} = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const username = useSelector((state) => state.loginUser.username);  
  const [data, setData] = useState(initialState);
  const [form, setForm] = useState(initialState[0]);
  const [filters, setFilters]= useState(initialFilters);
  const [applyFilters, setApplyFilters]= useState(initialFilters);
  const [numTotReg,setNumTotReg]= useState(0);
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [errorsFilters, setErrorsFilters] = useState({});
  const [errors, setErrors] = useState({});
  const [inputText, setInputText] = useState("");
  const [openCreateData,setOpenCreateData]= useState(false);
  const [openDeleteRow,setOpenDeleteRow]= useState(false);
  const [openEditRow,setOpenEditRow]= useState(false);
  const [openEditFilter,setOpenEditFilter]= useState(false);
  const [rowEdit,setRowEdit]= useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [idCodeDelete,setIdCodeDelete]=useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset]= useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(1);
  const [rangeOffset, setRangeOffset] = useState([{}]);
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(false);  
  const [rolesToSelect,setRolesToSelect]= useState(initialRolesToSelect);  
  const [storesToSelect,setStoresToSelect]= useState(initialStoreToSelect); 
  const [emailsToSelect,setEmailsToSelect]= useState(initialEmailToSelect);  
  const userNotToDelete=["Master","Admin","Provider","User","Employee",username];
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showUserSettings) {
        setData(initialState);
        setForm(initialState[0]);
        setFilters(initialFilters);
        setApplyFilters(initialFilters);
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({});
        setErrors({});
        setInputText("");
        setOpenCreateData(false);
        setOpenDeleteRow(false);
        setOpenEditRow(false);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]);
        dispatch(setLoading(false));
        setIsLoadingError(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffset(false);
        setCurrencyOffset(1);
        setRangeOffset([{}]);
        setShowPassword(false);
        setNewPassword(false);
        setRolesToSelect(initialRolesToSelect);
        setStoresToSelect(initialStoreToSelect);
        setEmailsToSelect(initialEmailToSelect);
        setShowPrincipalMenu(true);
        setShowModalUserSettings(false);
        setShowModalGeneralSettings(false);
      }
    },
    [
      setData,
      setForm,
      setFilters,
      setApplyFilters,
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters,
      setErrors,
      setInputText,
      setOpenCreateData,
      setOpenDeleteRow,
      setOpenEditRow,
      setOpenEditFilter,
      setRowEdit, 
      setIsLoadingError,
      setIdCodeDelete,
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,
      setShowPassword,
      setNewPassword,
      setRolesToSelect,
      setStoresToSelect,
      setEmailsToSelect,
      setShowPrincipalMenu,
      showUserSettings, 
      setShowModalUserSettings,
      setShowModalGeneralSettings,
      dispatch ]
  );

  const closeModalUserTypeSettings = () => {    
    setData(initialState);
    setForm(initialState[0]);
    setFilters(initialFilters);
    setApplyFilters(initialFilters);
    setNumTotReg(0);
    setNumTotRegFilter(0);
    setErrorsFilters({});
    setErrors({});
    setInputText("");
    setOpenCreateData(false);
    setOpenDeleteRow(false);
    setOpenEditRow(false);
    setOpenEditFilter(false);
    setRowEdit(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setIdCodeDelete(DELETE_CODE);
    setActiveOffset(false);
    setCurrencyOffset(1);
    setRangeOffset([{}]);
    setShowPassword(false);
    setNewPassword(false);
    setRolesToSelect(initialRolesToSelect);
    setStoresToSelect(initialStoreToSelect);
    setEmailsToSelect(initialEmailToSelect);
    setShowPrincipalMenu(true);
    setShowModalUserSettings(false);
    setShowModalGeneralSettings(false);
  };

  const openCreateOrEditData = () => {
    setInputText("");
    setOpenCreateData(true);
  };

  const openEditFilters = () => {
    setFilters(applyFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter());
    if (Object.keys(errorsFilters).length === 0) {
      setApplyFilters(filters);
      setFilters(initialFilters);
      setErrorsFilters({});
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setApplyFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setFilters(initialFilters);
    setOpenEditFilter(!openEditFilter);
  };

  const handleChangeEnabledFilter = (e) => {
    setFilters(filters => ({
      ...filters,
      isEnabled: !filters.isEnabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setFilters(filters => ({
      ...filters,
      isNotEnabled: !filters.isNotEnabled
    }));
  };

  const handleChangeisAccountNonLockedFilter = (e) => {
    setFilters(filters => ({
      ...filters,
      isAccountNonLocked: !filters.isAccountNonLocked
    }));
  };

  const handleChangeisNotAccountNonLockedFilter = (e) => {
    setFilters(filters => ({
      ...filters,
      isNotAccountNonLocked: !filters.isNotAccountNonLocked
    }));
  };
  
  const handleChangeFilterEdit = (e) => {
    const { name, value } = e.target;
    setFilters(filters => ({
      ...filters,
      [name]: value
    }));
  };

  const handleBlurFilterEdit = (e) => {
    setErrorsFilters(validateFormFilter());
    handleChangeFilterEdit(e);
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setFilters(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {

    let errorsFilters = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    let regexNumber = /^[0-9]+$/;
    if (filters.idFrom!=="" & !regexNumber.test(filters.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filters.idTo!=="" & !regexNumber.test(filters.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
    if (filters.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filters.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filters.idTo)<parseInt(filters.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    }

    if (filters.usernameFrom!=="" & regexInvalidCharacters.test(filters.usernameFrom)) {
      errorsFilters.usernameFrom = 'Text_TextNoValid';
    }    
    if (filters.usernameTo!=="" & regexInvalidCharacters.test(filters.usernameTo)) {
      errorsFilters.usernameTo = 'Text_TextNoValid';
    }
    if (filters.usernameTo!=="" & filters.usernameTo<filters.usernameFrom){
      errorsFilters.usernameTo = 'Text_TextGreater_Username';
    }

    if (filters.aliasuserFrom!=="" & regexInvalidCharacters.test(filters.aliasuserFrom)) {
      errorsFilters.aliasuserFrom = 'Text_TextNoValid';
    }    
    if (filters.aliasuserTo!=="" & regexInvalidCharacters.test(filters.aliasuserTo)) {
      errorsFilters.aliasuserTo = 'Text_TextNoValid';
    }
    if (filters.aliasuserTo!=="" & filters.aliasuserTo<filters.aliasuserFrom){
      errorsFilters.aliasuserTo = 'Text_TextGreater_AliasUser';
    }

    if (filters.firstNameFrom!=="" & regexInvalidCharacters.test(filters.firstNameFrom)) {
      errorsFilters.firstNameFrom = 'Text_TextNoValid';
    }    
    if (filters.firstNameTo!=="" & regexInvalidCharacters.test(filters.firstNameTo)) {
      errorsFilters.firstNameTo = 'Text_TextNoValid';
    }
    if (filters.firstNameTo!=="" & filters.firstNameTo<filters.firstNameFrom){
      errorsFilters.firstNameTo = 'Text_TextGreater_FirstName';
    }

    if (filters.lastName1From!=="" & regexInvalidCharacters.test(filters.lastName1From)) {
      errorsFilters.lastName1From = 'Text_TextNoValid';
    }    
    if (filters.lastName1To!=="" & regexInvalidCharacters.test(filters.lastName1To)) {
      errorsFilters.lastName1To = 'Text_TextNoValid';
    }
    if (filters.lastName1To!=="" & filters.lastName1To<filters.lastName1From){
      errorsFilters.lastName1To = 'Text_TextGreater_LastName1';
    }

    if (filters.lastName2From!=="" & regexInvalidCharacters.test(filters.lastName2From)) {
      errorsFilters.lastName2From = 'Text_TextNoValid';
    }    
    if (filters.lastName2To!=="" & regexInvalidCharacters.test(filters.lastName2To)) {
      errorsFilters.lastName2To = 'Text_TextNoValid';
    }
    if (filters.lastName2To!=="" & filters.lastName2To<filters.lastName2From){
      errorsFilters.lastName2To = 'Text_TextGreater_LastName2';
    }

    if (filters.emailFrom!=="" & regexInvalidCharacters.test(filters.emailFrom)) {
      errorsFilters.emailFrom = 'Text_TextNoValid';
    }    
    if (filters.emailTo!=="" & regexInvalidCharacters.test(filters.emailTo)) {
      errorsFilters.emailTo = 'Text_TextNoValid';
    } 
    if (filters.emailTo!=="" & filters.emailTo<filters.emailFrom){
      errorsFilters.emailTo = 'Text_TextGreater_Email';
    }
    
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
      String(el.id || '') +
      String(el.username || '') +
      String(el.aliasuser || '') +
      String(el.firstName || '') +
      String(el.lastName1 || '') +
      String(el.lastName2 || '');
    let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
    return result; 
    }
  })

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRow = () => {
    setErrors({});
    setRowEdit(initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setShowPassword(false);
    setNewPassword(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `useraccount/deleteuseraccount`, token, rowEdit);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
            } else {
              dispatch(warningErrorAction(t(getData.cause)));
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    }
  
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
  };

  const handleSubmitDataEdit = () => {
    setErrors(validateForm());
    const errorsToCheck = validateForm();
  
    if ((Object.keys(errorsToCheck).length === 0) 
      && form.username!==''  
      && form.aliasuser!=='' 
      && form.store_id!==undefined && form.store_id!==null 
      && form.store_id!=='' && form.store_id!=='0' && form.store_id!==0 
      && form.useraccount_email!==''
    ) {
      const fetchData = async (form) => {
        dispatch(setLoading(true));
        try {
          const getData = openEditRow
            ? await helpHttp().put(ENDPOINT, `useraccount/updateuseraccount`, token, form)
            : await helpHttp().post(ENDPOINT, `useraccount/saveuseraccount`, token, form);
  
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
            dispatch(setLoading(false));
            handleCloseDataEdit();
          } else {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.cause)));
          } 
        } catch (error) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        } 
      };
      if (form.destinestore_id 
         && !form.destinestore_id!==null  
          && !form.destinestore_id!=="" 
          && !form.destinestore_id!=="0" 
          && !form.destinestore_id!==0
          && emailsToSelect && emailsToSelect.length>0){
        let idx=emailsToSelect.findIndex(((item) => form.destinestore_id));
          setForm(form => ({
            ...form,
            destinestore_name:emailsToSelect[idx].tradename ,
            emaildestine:emailsToSelect[idx].contacemail
          }));
      }
      fetchData(form);
    } else {
      if (errorsToCheck.username) {
        dispatch(warningErrorAction(t(errorsToCheck.username)));
      } else if (errorsToCheck.aliasuser) {
        dispatch(warningErrorAction(t(errorsToCheck.aliasuser)));
      } else if (errorsToCheck.password) {
        dispatch(warningErrorAction(t(errorsToCheck.password)));
      } else if (errorsToCheck.firstName) {
        dispatch(warningErrorAction(t(errorsToCheck.firstName)));
      } else if (errorsToCheck.lastName1) {
        dispatch(warningErrorAction(t(errorsToCheck.lastName1)));
      } else if (errorsToCheck.email) {
        dispatch(warningErrorAction(t(errorsToCheck.email)));
      } else if (errorsToCheck.role_id) {
        dispatch(warningErrorAction(t(errorsToCheck.role_id)));
      } else if (errorsToCheck.store_id) {
        dispatch(warningErrorAction(t(errorsToCheck.store_id)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  const handleCloseDataEdit = () => {
    setOpenCreateData(false);
    setOpenEditRow(false);
    setErrors({});
    setRowEdit(openEditRow?rowEdit:initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false));
    setIsLoadingError(false);
    setShowPassword(false);
    setNewPassword(false);
    toggleDrawerDataEdit(false);
	};

  const handleBlurSelectStore = (event) => {
    handleChangeSelectStore(event);
    setErrors(validateForm());
  };

  const handleChangeSelectStore = (event) => {
    setForm(form => ({
      ...form,
      store_id:event.target.value 
    }));
  };

 
  const handleBlurSelectRole = (e) => {
    handleChangeSelectRole(e);
    setErrors(validateForm());
  };

  const handleChangeSelectRole = (event) => {
    setForm(form => ({
        ...form,
        role_id:event.target.value
    }));
  };
 
  const handleisAccountNonLocked = (e) => {
    setForm(form => ({
      ...form,
      isAccountNonLocked: !form.isAccountNonLocked
    }));
  };
  
  const handleChangeEnabled = (e) => {
    setForm(form => ({
      ...form,
      enabled: !form.enabled
    }));
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleDeletePassword = () => {
    setForm(form => ({
      ...form,
      password: ""
    }));
    setNewPassword(true);
  };

  const handleBlurDataEdit = (e) => {
    handleChangeDataEdit(e);
    setErrors(validateForm());
  };
  
  const handleChangeDataEdit = (e) => {
    const { name, value } = e.target;
    setForm(form => ({
      ...form,
      [name]: value
    }));
  };

  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };

  const validateForm = () => {
    let errors = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (!form.username || form.username==="") {
      errors.username = 'Text_FieldUsernameRequired';
    } else {
      if (regexInvalidCharacters.test(form.username)) {
        errors.username = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.username.toLowerCase()===form.username.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.username = 'Text_User_UserNameExist';
          }
        } else {
          if (data.find((key=>key.username.toLowerCase()===form.username.toLowerCase()))) {
            errors.username = 'Text_User_UserNameExist';
          }
        }  
      }   
    }
    if (!form.aliasuser || form.aliasuser==="") {
      errors.aliasuser = 'Text_FieldAliasuserRequired';
    } else {
      if (regexInvalidCharacters.test(form.aliasuser)) {
        errors.aliasuser = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.aliasuser.toLowerCase()===form.aliasuser.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.aliasuser = 'Text_User_AliasuserExist';
          }
        } else {
          if (data.find((key=>key.aliasuser.toLowerCase()===form.aliasuser.toLowerCase()))) {
            errors.aliasuser = 'Text_User_AliasuserExist';
          }
        }   
      }  
    }
   
    if (!form.firstName || form.firstName==="") {
      errors.firstName = 'Text_FieldFirstNameRequired';
    }else {
      if (regexInvalidCharacters.test(form.firstName)) {
        errors.firstName = 'Text_TextNoValid';
      }
    }  

    if (!form.lastName1 || form.lastName1==="") {
      errors.lastName1 = 'Text_FieldLastName1Required';
    }else {
      if (regexInvalidCharacters.test(form.lastName1)) {
        errors.lastName1 = 'Text_TextNoValid';
      }
    } 
    if (form.lastName2!=="" && regexInvalidCharacters.test(form.lastName2)) {
      errors.lastName2 = 'Text_TextNoValid';
    }

    if (form.emaildestine!=="" && regexInvalidCharacters.test(form.emaildestine)) {
      errors.emaildestine = 'Text_TextNoValid';
    }

    if (!form.email || form.email==="") {
      errors.email = 'Text_FieldEmailRequired';
    } else {
      if (regexInvalidCharacters.test(form.email)) {
        errors.email = 'Text_TextNoValid';
      } else{
      if (openEditRow){
          if (data.find((key=>(key.email.toLowerCase()===form.email.toLowerCase().trim() && key.id!==rowEdit.id)))) {
            errors.email = 'Text_User_EmailExist';
          }
        } else {
          if (data.find((key=>key.email.toLowerCase()===form.email.toLowerCase().trim()))) {
            errors.email = 'Text_User_EmailExist';
          }
        }  
      }     
    }  

    if (form.role_id===undefined || form.role_id===null || form.role_id==="" || form.role_id==="0" || form.role_id===0) {
      errors.role_id = 'Text_FieldRoleRequired';
    }

    if (form.store_id===undefined || form.store_id===null || form.store_id==="" || form.store_id==="0" || form.store_id===0) {
      errors.store_id = 'Text_FieldStoreRequired';
    }
 
    return errors;
  };

  useEffect(() => {
    setForm(openEditRow?rowEdit:initialState[0]);
  },[rowEdit,openEditRow]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegFilter>LIMIT_PAGE_SIZE){
      setActiveOffset(true);
      setRangeOffset([
        { value: 0,
          label: " 1 - "+Number(LIMIT_PAGE_SIZE).toLocaleString('de-DE'),
        }
      ]);
      for (let i = Number(LIMIT_PAGE_SIZE); i<numTotRegFilter; i=i+ Number(LIMIT_PAGE_SIZE)){
        setRangeOffset(
          current=>[
            ...current,
            ...[
              {
                value: i,
                label: " "+(i+1).toLocaleString('de-DE')+" - "+(i+Number(LIMIT_PAGE_SIZE)).toLocaleString('de-DE'),
              }
            ]
          ]
        )
      }
    } else{
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  },[numTotRegFilter]);

  useEffect(() => {
    let ignore = false;
       
    const fetchDataRole = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `roleuser/rolesorderbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (!ignore) {
          setRolesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchDataStore = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `store/storesorderbyname`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (!ignore) {
          setStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    const fetchDataEmails = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`store/getemailliststores`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (!ignore) {
          setEmailsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 

    if ((openCreateData || openEditRow || openEditFilter)){
       fetchDataRole(); 
      fetchDataStore(); 
      fetchDataEmails();
      return () => { ignore = true };
    }
  }, [t,token,dispatch,i18n,roles,openCreateData,openEditRow,openEditFilter]);
 
  useEffect(() => {
    let ignore = false;  
    const fetchnumTotReg = async () => { 
      try {
        const getData = await helpHttp().get(ENDPOINT, `useraccount/getinformationtableuseraccount`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchnumTotRegFilter = async () => { 
      try {
        const getData = await helpHttp().post(ENDPOINT, `useraccount/getcountfilteruseraccounts`, token, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchData = async () => {
       dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `useraccount/useraccounts`, token, currencyOffset, LIMIT_PAGE_SIZE, applyFilters);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    if (showUserSettings) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [t, token, dispatch, openCreateData, openDeleteRow, openEditRow, rowEdit, showUserSettings, applyFilters, currencyOffset]);
  return (
    <>
      {showUserSettings ? ( 
        <div className="container-fluid formdi-pending-page">
          {/* Search input */}
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRow?"warning":"primary"}/>:<i className="fas fa-solid fa-user text-warning"></i>} {t('Text_User_Config')}
            </h1>
            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_UserAccount_Create'))? (
              <div>
                <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditData} >
                  {t('Button_Create')}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalUserTypeSettings} >
                  {t('Button_Back')}
                </button>
              </div>
            ) : (
              <div>
                <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalUserTypeSettings} >
                  {t('Button_Back')}
                </button>
              </div>
            )} 
          </div>  
          <br/>
           
          {!isLoadingData ?
          <>
            <div className="formdi-pending-search">
              <TextField
                id="outlined-basic"
                variant="outlined"
                value={inputText}
                inputProps={{ style: {fontSize: '18px'} }}
                InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
                placeholder={t('Text_User_Search')}
                onChange={inputHandler}
                fullWidth
                label={t('Text_User_Search')}>
              </TextField>
            </div>
            <br/>
            <div id="myNewDIV" className="formdi-pending-filters">
              <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
              <div className="formdi-pending-filters-row">
                <button type="button" className={`formdi-pending-chip ${applyFilters.idFrom !== "" || applyFilters.idTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.idFrom !== "" || applyFilters.idTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Code")}
                </button>
                <button type="button" className={`formdi-pending-chip ${applyFilters.usernameFrom !== "" || applyFilters.usernameTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.usernameFrom !== "" || applyFilters.usernameTo !== ""? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_User")}
                </button> 
                <button type="button" className={`formdi-pending-chip ${ applyFilters.aliasuserFrom!=="" || applyFilters.aliasuserTo!=="" 
                    || applyFilters.firstNameFrom!=="" || applyFilters.firstNameTo!==""
                    || applyFilters.lastName1From!=="" || applyFilters.lastName1To!==""  
                    || applyFilters.emailFrom!=="" || applyFilters.emailTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${  applyFilters.aliasuserFrom!=="" || applyFilters.aliasuserTo!=="" 
                    || applyFilters.firstNameFrom!=="" || applyFilters.firstNameTo!==""
                    || applyFilters.lastName1From!=="" || applyFilters.lastName1To!==""   
                    || applyFilters.emailFrom!=="" || applyFilters.emailTo!=="" ? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Others_Filters")}
                </button>
                <button type="button" className={`formdi-pending-chip ${applyFilters.isEnabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.isEnabled? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Enabled")}
                </button> 
                <button type="button" className={`formdi-pending-chip ${applyFilters.isNotEnabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.isNotEnabled? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Not_Enabled")}
                </button> 
                <button type="button" className={`formdi-pending-chip ${applyFilters.isAccountNonLocked ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.isAccountNonLocked? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Account_Not_Locked")}
                </button> 
                <button type="button" className={`formdi-pending-chip ${applyFilters.isNotAccountNonLocked ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                  <span className={`formdi-pending-dot ${ applyFilters.isNotAccountNonLocked? "formdi-pending-dot--on": ""}`}/>
                    {t("Text_Account_Locked")}
                </button>  
              </div>
            </div>
            <br/>  
           <div className="formdi-pending-card-flat">
              <div className="formdi-pending-card-content">
                <TableSortingUserAccount
                  data={filteredData}
                  headCells={headCells}
                  numTotRegFilter={numTotRegFilter}
                  titleTable={t('Text_User_Table')}
                  setOpenDeleteRow={setOpenDeleteRow}
                  setOpenEditRow={setOpenEditRow}
                  setRowEdit={setRowEdit}
                  showEditButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_UserAccount_Edit'))?true:false}
                  showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='SubMenu_UserAccount_Delete'))?true:false}
                  numTotReg={numTotReg}
                  activeOffset={activeOffset}
                  rangeOffset={rangeOffset}
                  currencyOffset={currencyOffset}
                  setCurrencyOffset={setCurrencyOffset}
                  username={username}
                  minvalue={Number(NON_ERASABLE_USERACCOUNT_ID)}>
                </TableSortingUserAccount>
              </div>             
            </div>
            {openEditFilter &&
              <div>
                <SwipeableDrawer
                  anchor='right'
                  open={true}
                  onClose={toggleDrawerFilterEdit(false)}
                  onOpen={toggleDrawerFilterEdit(true)}>
                   <Container >
                    <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                      <br/>
                      <div id="myDIV">
                        <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                      </div>
                      <hr className="sidebar-divider d-none d-md-block"/>
                      <form className="createfilter" onSubmit={handleCancelFilters}>  
                        <div className="form-floating mb-3 px-4 primary">
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="idFrom" 
                              name="idFrom"
                              value={filters.idFrom}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.idFrom!=null?t(errorsFilters.idFrom):t('PlaceHolder_Filter_Code_From')}
                              placeholder={t('PlaceHolder_Filter_Code_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Code_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="idTo" 
                              name="idTo"
                              value={filters.idTo}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.idTo!=null?t(errorsFilters.idTo):t('PlaceHolder_Filter_Code_to')}
                              placeholder={t('PlaceHolder_Filter_Code_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_UserName_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="usernameFrom" 
                              name="usernameFrom"
                              value={filters.usernameFrom}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.usernameFrom!=null?t(errorsFilters.usernameFrom):t('PlaceHolder_Filter_UserName_From')}
                              placeholder={t('PlaceHolder_Filter_UserName_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_UserName_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="usernameTo" 
                              name="usernameTo"
                              value={filters.usernameTo}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.usernameTo!=null?t(errorsFilters.usernameTo):t('PlaceHolder_Filter_UserName_to')}
                              placeholder={t('PlaceHolder_Filter_UserName_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_AliasUser_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="aliasuserFrom" 
                              name="aliasuserFrom"
                              value={filters.aliasuserFrom}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.aliasuserFrom!=null?t(errorsFilters.aliasuserFrom):t('PlaceHolder_Filter_AliasUser_From')}
                              placeholder={t('PlaceHolder_Filter_AliasUser_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_AliasUser_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="aliasuserTo" 
                              name="aliasuserTo"
                              value={filters.aliasuserTo}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.aliasuserTo!=null?t(errorsFilters.aliasuserTo):t('PlaceHolder_Filter_AliasUser_to')}
                              placeholder={t('PlaceHolder_Filter_AliasUser_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Name_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="firstNameFrom" 
                              name="firstNameFrom"
                              value={filters.firstNameFrom}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.firstNameFrom!=null?t(errorsFilters.firstNameFrom):t('PlaceHolder_Filter_Name_From')}
                              placeholder={t('PlaceHolder_Filter_Name_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Name_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="firstNameTo" 
                              name="firstNameTo"
                              value={filters.firstNameTo}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.firstNameTo!=null?t(errorsFilters.firstNameTo):t('PlaceHolder_Filter_Name_to')}
                              placeholder={t('PlaceHolder_Filter_Name_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_LastName1_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName1From" 
                              name="lastName1From"
                              value={filters.lastName1From}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.lastName1From!=null?t(errorsFilters.lastName1From):t('PlaceHolder_Filter_LastName1_From')}
                              placeholder={t('PlaceHolder_Filter_LastName1_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_LastName1_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName1To" 
                              name="lastName1To"
                              value={filters.lastName1To}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.lastName1To!=null?t(errorsFilters.lastName1To):t('PlaceHolder_Filter_LastName1_to')}
                              placeholder={t('PlaceHolder_Filter_LastName1_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_LastName2_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName2From" 
                              name="lastName2From"
                              value={filters.lastName2From}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                              label={errorsFilters.lastName2From!=null?t(errorsFilters.lastName2From):t('PlaceHolder_Filter_LastName2_From')}
                              placeholder={t('PlaceHolder_Filter_LastName2_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_LastName2_To')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName2To" 
                              name="lastName2To"
                              value={filters.lastName2To}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.lastName2To!=null?t(errorsFilters.lastName2To):t('PlaceHolder_Filter_LastName2_to')}
                              placeholder={t('PlaceHolder_Filter_LastName2_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Email_From')} :</label>
                          <div className="form-group">
                            <TextField
                              id="emailFrom" 
                              name="emailFrom"
                              value={filters.emailFrom}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.emailFrom!=null?t(errorsFilters.emailFrom):t('PlaceHolder_Filter_Email_From')}
                              placeholder={t('PlaceHolder_Filter_Email_From')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Filter_Email_to')} :</label>
                          <div className="form-group">
                            <TextField
                              id="emailTo" 
                              name="emailTo"
                              value={filters.emailTo}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errorsFilters.emailTo!=null?t(errorsFilters.emailTo):t('PlaceHolder_Filter_Email_to')}
                              placeholder={t('PlaceHolder_Filter_Email_to')}
                              variant="standard"
                              onBlur={handleBlurFilterEdit}
                              onChange={handleChangeFilterEdit}/>
                          </div>
                          
                          <div className="form-group">
                            <Checkbox
                              id="isEnabled" 
                              name="isEnabled"
                              checked={filters.isEnabled}
                              onChange={handleChangeEnabledFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Enabled')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                            <Checkbox
                              id="isNotEnabled" 
                              name="isNotEnabled"
                              checked={filters.isNotEnabled}
                              onChange={handleChangeNotEnabledFilter}
                              variant="standard"
                              
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Not_Enabled')}</label>    
                          </div>
                          <div className="form-group">
                          <Checkbox
                              id="isAccountNonLocked" 
                              name="isAccountNonLocked"
                              checked={filters.isAccountNonLocked}
                              onChange={handleChangeisAccountNonLockedFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_isAccountNonLocked')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <Checkbox
                              id="isNotAccountNonLocked" 
                              name="isNotAccountNonLocked"
                              checked={filters.isNotAccountNonLocked}
                              onChange={handleChangeisNotAccountNonLockedFilter}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_isNotAccountNonLocked')}</label>    
                          </div>
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div>
                        </div>
                      </form>
                    </Box>
                  </Container>
                </SwipeableDrawer>
              </div>
            }
            {(openCreateData || openEditRow) && 
              <div>
                <SwipeableDrawer
                  anchor='right'
                  open={true}
                  onClose={toggleDrawerDataEdit(false)}
                  onOpen={toggleDrawerDataEdit(true)}>
                  <Container >
                    <Box sx={{ bgcolor: '#ffffff',height:'100vh', width: '500px' }}>
                      <br/>
                      <div id="myDIV">
                        <h1 className="h1NewStyle px-4 mb-2">{openEditRow?t('Text_User_Edit'):t('Text_User_Create')}</h1>
                      </div>  
                      <hr className="sidebar-divider d-none d-md-block"/>
                      <form className="createuseraacount" onSubmit={handleSubmitDataEdit}>  
                        <div className="form-floating mb-3 px-4 primary">
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Code')} :</label>
                          <div className="form-group">
                            <TextField
                              id="id" 
                              name="id"
                              value={form.id}
                              inputProps={{ style: {width:  200,  fontSize: '18px', }, maxLength: 15 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}   
                              label={t('PlaceHolder_User_Code')}
                              placeholder={t('PlaceHolder_User_Code')}
                              variant="standard"
                              disabled/>
                          </div>                        
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_User')} :</label>
                          <div className="form-group">
                            <TextField
                              id="username" 
                              name="username"
                              value={form.username}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.username!=null?t(errors.username):t('PlaceHolder_User_Username')}
                              placeholder={t('PlaceHolder_User_Username')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}
                              disabled={openEditRow}
                              />
                          </div>
                          
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_AliasUser')} :</label>
                          <div className="form-group">
                            <TextField
                              id="aliasuser" 
                              name="aliasuser"
                              value={form.aliasuser}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.aliasuser!=null?t(errors.aliasuser):t('PlaceHolder_User_AliasUser')}
                              placeholder={t('PlaceHolder_User_AliasUser')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Password')} :</label>
                          <div className="form-group">
                            <TextField
                              id="password" 
                              name="password"
                              type={showPassword ? 'text' : 'password'}
                              value={form.password}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 256 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.password!=null?t(errors.password):t('PlaceHolder_User_Password')}
                              placeholder={t('PlaceHolder_User_Password')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}
                              disabled={openEditRow && ! newPassword}
                              InputProps={{
                                style: {width: 450,  fontSize: '18px'},
                                endAdornment: (
                                  <InputAdornment position="end"
                                    onClick={handleClickShowPassword}>
                                    {showPassword?<VisibilityOff style={{fontSize: 28}}/>:<Visibility style={{fontSize: 28}}/>}
                                  </InputAdornment>
                                ),
                                startAdornment: (
                                  <InputAdornment position="start"
                                    onClick={handleDeletePassword}>
                                    <DeleteIcon style={{fontSize: 28}}/>
                                  </InputAdornment>
                                )
                              }}
                              />
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Name')} :</label>
                          <div className="form-group">
                            <TextField
                              id="firstName" 
                              name="firstName"
                              value={form.firstName}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.firstName!=null?t(errors.firstName):t('PlaceHolder_User_Name')}
                              placeholder={t('PlaceHolder_User_Name')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_LastName1')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName1" 
                              name="lastName1"
                              value={form.lastName1}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.lastName1!=null?t(errors.lastName1):t('PlaceHolder_User_LastName1')}
                              placeholder={t('PlaceHolder_User_LastName1')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_LastName2')} :</label>
                          <div className="form-group">
                            <TextField
                              id="lastName2" 
                              name="lastName2"
                              value={form.lastName2}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.lastName2!=null?t(errors.lastName2):t('PlaceHolder_User_LastName2')}
                              placeholder={t('PlaceHolder_User_LastName2')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Email')} :</label>
                          <div className="form-group">
                            <TextField
                              id="email" 
                              name="email"
                              value={form.email}
                              inputProps={{ style: {width:  450,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.email!=null?t(errors.email):t('PlaceHolder_User_Email')}
                              placeholder={t('PlaceHolder_User_Email')}
                              variant="standard"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}/>
                          </div>
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_EmailDestine')} :</label>
                          <div className="form-group">
                            <TextField
                              id="destinestore_id" 
                              name="destinestore_id"
                              value={form.destinestore_id}
                              inputProps={{ style: {width:  405,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              label={errors.destinestore_id!=null?t(errors.destinestore_id):t('Placeholder_EmailDestine')}
                              placeholder={t('Placeholder_EmailDestine')}
                              variant="outlined"
                              onBlur={handleBlurDataEdit}
                              onChange={handleChangeDataEdit}
                              select
                              SelectProps={{
                              native: true,
                              }}>
                              <option key={0} value=""/>
                              {emailsToSelect.map((option) => (
                              <option key={option.id} value={option.id}>
                                  {option.tradename}  - {option.contacemail}
                              </option>
                              ))}
                            </TextField>
                          </div>
                          <div className="form-group">
                            <Checkbox
                              id="enabled" 
                              name="enabled"
                              checked={form.enabled}
                              onChange={handleChangeEnabled}
                              disabled={userNotToDelete.includes(form.username)}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Enabled')}</label>  
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                            <Checkbox
                              id="isAccountNonLocked" 
                              name="isAccountNonLocked"
                              checked={form.isAccountNonLocked}
                              onChange={handleisAccountNonLocked}
                              disabled={userNotToDelete.includes(form.username)}
                              variant="standard"
                              sx={{
                                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                              }}
                            />
                            &nbsp;&nbsp;    
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_isAccountNonLocked')}</label>    
                          </div> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_User_Roles')} :</label>
                          <div className="form-group">
                            <TextField
                              id="role_id"
                              name="role_id"
                              value={ 
                                (form.role_id!== undefined ||
                                form.role_id!== null ||
                                form.role_id!== "" ||
                                form.role_id!== "0" ||
                                form.role_id!== 0 ) ? form.role_id:Number(DEFAULT_ROLE)}
                              inputProps={{ style: {width:  405,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              variant="outlined"
                              onBlur={handleBlurSelectRole}
                              onChange={handleChangeSelectRole}
                              disabled={userNotToDelete.includes(form.username)}
                              helperText={errors.role_id!=null?t(errors.role_id):""}
                              select
                              SelectProps={{
                                  native: true,
                                  value: 
                                    (form.role_id!== undefined ||
                                      form.role_id!== null ||
                                      form.role_id!== "" ||
                                      form.role_id!== "0" ||
                                      form.role_id!== 0 ) ? form.role_id:Number(DEFAULT_ROLE)
                                  }}>
                                  {rolesToSelect.filter(item=>(roles[0].listmenus.find((key)=>(key.name==='SubMenu_UserAccount_Handle_Role_Master')))?item.id!==0:item.id!==1).map(option => (
                                  <option key={option.id} value={option.id}>
                                      {option.name}
                                  </option>
                                  ))}
                            </TextField>
                          </div> 
                          <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_User_Stores')} :</label>
                          <div className="form-group">
                            <TextField
                              id="store_id"
                              name="store_id"
                              value={ 
                                (form.store_id!== undefined ||
                                form.store_id!== null ||
                                form.store_id!== "" ||
                                form.store_id!== "0" ||
                                form.store_id!== 0 ) ? form.store_id:Number(DEFAULT_STORE)}
                              inputProps={{ style: {width:  405,  fontSize: '18px', }, maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                              variant="outlined"
                              onBlur={handleBlurSelectStore}
                              onChange={handleChangeSelectStore}
                              helperText={errors.store_id!=null?t(errors.store_id):""}
                              select
                              SelectProps={{
                                  native: true,
                                  value: 
                                    (form.store_id!== undefined ||
                                      form.store_id!== null ||
                                      form.store_id!== "" ||
                                      form.store_id!== "0" ||
                                      form.store_id!== 0 ) ? form.store_id:Number(DEFAULT_STORE)
                                  }}>
                                  {storesToSelect.map((option) => (
                                  <option key={option.id} value={option.id}>
                                      {option.tradename}
                                  </option>
                                  ))}
                            </TextField>
                          </div>
                          <hr className="sidebar-divider d-none d-md-block"/>
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitDataEdit}>
                              {openEditRow?t('Button_Update'):t('Button_Create')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseDataEdit}>
                              {t('Button_Cancel')}
                            </button>
                          </div>    
                        </div>
                      </form>
                    </Box>
                  </Container>
                </SwipeableDrawer>
              </div>
            } 
            <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
              <DialogTitle className="my-dialog-title-danger">
                {t('Text_Delete')} {rowEdit.id}  - {rowEdit.username}
              </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}<br />
                    {t("Text_Line2")}
                  </DialogContentText>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="idCode"
                      label={t("Text_Label")}
                      type="text"
                      fullWidth
                      variant="standard"
                      className="my-dialog-input-danger"
                      defaultValue={idCodeDelete}
                      onChange={handleChangeDeleteRow}
                    />
                  </DialogContent>
                <DialogActions className="my-dialog-actions">
                <Button
                  onClick={handleCancelDeleteRow}
                  className="my-dialog-button-cancel-danger"
                >
                  {t("Button_Cancel")}
                </Button>
                <Button
                  variant="contained"
                  onClick={handleCloseDeleteRow}
                  className="my-dialog-button-delete"
                >
                  {t("Button_Delete")}
                </Button>
              </DialogActions>
            </Dialog>  
            {/* End Content Row */}
          </>:
            <LoadingNews/>
          }
        </div>
        //* End Page Content *//
      ) :  null }
    </>
  )
}

UserSettings.propTypes = {
  setShowPrincipalMenu: PropTypes.func.isRequired,
  showUserSettings: PropTypes.bool.isRequired,
  setShowModalUserSettings: PropTypes.func.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired 
};

export default UserSettings;